import { Component, Input } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-autorolloversucess-alert',
  standalone: false,
  templateUrl: './custom-autorolloversucess-alert.component.html',
  styleUrls: ['./custom-autorolloversucess-alert.component.scss']
})
export class CustomAutorolloversucessAlertComponent {
  showBanner: boolean = false;
  constructor(private userInfoService: UserInfoService, public componentData: CmsComponentData<any>) { }
  @Input() cmsContent: any;
  ngOnInit() {
    this.userInfoService.getAutoRollOverAlert().subscribe((data) => {
      if(!data) {
      this.dismissBanner();
      }
      else{
        this.showBanner = true;
      }
    });
  }
  //method to dismiss the banner  
  dismissBanner() {
    this.showBanner = false;
    // sessionStorage.removeItem('autoRolloverSuccess');
  }
  // when navigating to other page and coming back to my profile then to dismiss the banner
  ngOnDestroy() {
    this.userInfoService.setAutoRollOverAlert(false);
  }
}
